// start assets/custom-scripts



/* Theme mod by Vasta 04/08 - Show More App  */
  var btn_show_more = document.querySelector('#Show_More_App');
  jQuery('.embed-container iframe').attr('scrolling', 'no');
  btn_show_more.addEventListener('click', function() {

    if(jQuery('#des_last_show').hasClass("show_more_div_closed")){
	  jQuery('.embed-container iframe').attr('scrolling', 'yes');
      jQuery('#des_last_show').removeClass('show_more_div_closed')
      jQuery('#Show_More_App').html("Click Here to Learn More -");
    }else{
	  jQuery('.embed-container iframe').attr('scrolling', 'no');
      jQuery(".embed-container iframe").contents().scrollTop(0)
      jQuery('#des_last_show').addClass('show_more_div_closed')
      jQuery('#Show_More_App').html("Click Here to Learn More +");
    }
  });  

/* End Theme mod by Vasta 04/08 - Show More App  */